var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5.69565L7.26087 7.13906M7.26087 7.13906L10.3913 19.4172H23.3043L28 7.13906H7.26087Z",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6834 27.9998C12.9389 27.9998 13.9567 26.9009 13.9567 25.5453C13.9567 24.1897 12.9389 23.0908 11.6834 23.0908C10.4279 23.0908 9.41016 24.1897 9.41016 25.5453C9.41016 26.9009 10.4279 27.9998 11.6834 27.9998Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1385 27.9998C23.394 27.9998 24.4118 26.9009 24.4118 25.5453C24.4118 24.1897 23.394 23.0908 22.1385 23.0908C20.883 23.0908 19.8652 24.1897 19.8652 25.5453C19.8652 26.9009 20.883 27.9998 22.1385 27.9998Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPurchase);
export default __webpack_public_path__ + "static/media/MyPurchase.f7fb4d60ffe1134ce3aabe90ac7dd6e1.svg";
export { ForwardRef as ReactComponent };